import * as React from 'react'

import { Text, Util } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

const OpticianForm = () => {
  const { getLabel } = useIntl()

  return (
    <>
      <Text
        id="opticianName"
        data-t="optician-name"
        label={getLabel('products.contactLens.info.optician.name')}
        errorMessage={getLabel('products.contactLens.info.optician.name.errorMessage')}
        maxLength={40}
        validations={[Util.validations.isNotLeadingWhitespace, Util.validations.isText]}
      />
    </>
  )
}

export default OpticianForm
